// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import AdvanceReturnedPartInfoForm from './advance-returned-part-info-form';
import {FormattedMessage} from 'react-intl';
import RgaConsignmentDetails from '../../../rga-search-results/state/rga-consignment-details';
import RgaDealerDetails from '../../../rga-search-results/state/rga-dealer-details';
import RgaDetails from '../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';

const AdvanceReturnedPartInfoAccordion = props => {

    const body = (
        <AdvanceReturnedPartInfoForm
            actions={props.actions}
            busyCounter={props.busyCounter}
            queryParams={props.queryParams}
            rgaConsignmentDetails={props.rgaConsignmentDetails}
            rgaDealerDetails={props.rgaDealerDetails}
            rgaDetails={props.rgaDetails}
            security={props.security}
        />
    );

    const title = (
        <FormattedMessage
            id='Dealer and Consignment Information'
        />
    );

    return true &&
        <Accordion
            accordionId='part-request-analysis-accordion'
            body={body}
            isExpanded={props.queryParams && (props.queryParams.tab === 'dealerInfo' || props.queryParams.tab === 'consignmentInfo')}
            secondaryHeaderNode={null}
            title={title}
        />;

};

AdvanceReturnedPartInfoAccordion.displayName = 'AdvanceReturnedPartInfoAccordion';
AdvanceReturnedPartInfoAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    queryParams: PropTypes.object.isRequired,
    rgaConsignmentDetails: PropTypes.instanceOf(RgaConsignmentDetails).isRequired,
    rgaDealerDetails: PropTypes.instanceOf(RgaDealerDetails).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default AdvanceReturnedPartInfoAccordion;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/advance-returned-part-information/advance-returned-part-information-accordion.js